import { getApiData } from './APIHelper';
import { Setting } from './Setting';

/**
 * Initiates a contractor onboarding workflow by calling the steps/map API
 * @param {number} refId - The reference ID (user/contractor ID)
 * @param {string} token - The authentication token
 * @returns {Promise<boolean>} - Returns true if successful, false otherwise
 */
export const initiateContractorOnboardingWorkflow = async (refId, token) => {
  try {
    if (!token) {
      console.log('No token available for contractor onboarding workflow initiation');
      return false;
    }

    if (!refId) {
      console.log('No refId available for contractor onboarding workflow initiation');
      return false;
    }

    const workflowData = {
      refId: parseInt(refId),
      refType: "contractor",
      workflowName: "CONTRACTOR_ONBOARDING"
    };
    
    console.log('Initiating contractor onboarding workflow:', workflowData);
    
    const response = await getApiData(
      Setting.endpoints.stepsMap,
      "POST",
      workflowData,
      { 
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      true // Use new base URL
    );
    
    if (response.success) {
      console.log('Contractor onboarding workflow initiated successfully:', response);
      return true;
    } else {
      console.log('Failed to initiate contractor onboarding workflow:', response);
      return false;
    }
  } catch (error) {
    console.log('Error initiating contractor onboarding workflow:', error);
    return false;
  }
};

/**
 * Updates a workflow step mapping to COMPLETED status
 * @param {number} refId - The reference ID (user/contractor ID)
 * @param {string} stepName - The step name to update (e.g., "CREATE_ACCOUNT", "DOCUMENT_SUBMIT", "PORTFOLIO")
 * @param {string} token - The authentication token
 * @returns {Promise<boolean>} - Returns true if successful, false otherwise
 */
export const updateStepMappingToCompleted = async (refId, stepName, token) => {
  try {
    if (!token) {
      console.log(`No token available for ${stepName} step mapping`);
      return false;
    }

    if (!refId) {
      console.log(`No refId available for ${stepName} step mapping`);
      return false;
    }

    const stepMappingData = {
      refId: parseInt(refId),
      refType: "contractor",
      workflowName: "CONTRACTOR_ONBOARDING",
      stepName: stepName,
      state: "COMPLETED"
    };
    
    console.log(`Updating ${stepName} step mapping to completed:`, stepMappingData);
    
    const response = await getApiData(
      Setting.endpoints.stepMapping,
      "PUT",
      stepMappingData,
      { 
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      true // Use new base URL
    );
    
    // Check for success - API might return the data directly or with a success flag
    if (response.success === true || (response && response.state === "COMPLETED")) {
      console.log(`${stepName} step mapping updated to completed successfully:`, response);
      // Dispatch custom event to notify components that workflow steps have changed
      window.dispatchEvent(new CustomEvent('workflowStepsUpdated', { detail: { stepName } }));
      return true;
    } else {
      console.log(`Failed to update ${stepName} step mapping to completed:`, response);
      return false;
    }
  } catch (error) {
    console.log(`Error updating ${stepName} step mapping to completed:`, error);
    return false;
  }
};
